import { useCookies } from "react-cookie";
import { Navigate, Outlet } from "react-router-dom";
import { useRecoilState } from "recoil";
import { darkModeState } from "../atoms/darkMode";

const PrivateRoutes = () => {
  const [token] = useCookies(["jwt"]);
  const [darkMode, setDarkMode] = useRecoilState(darkModeState);
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.user?.user_role?.name;

  if (token && role === "MEM") {
    return <Outlet />;
  } else {
    // Çıkış yapıldığında dark mode'u kapat ama tercihi silme
    setDarkMode(false);
    document.body.classList.remove('dark-mode');
    document.documentElement.classList.remove('dark-mode');
    // localStorage.removeItem('darkMode'); // Tercihi silme, sadece kapat
    
    localStorage.removeItem("user");
    document.cookie = `jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    return <Navigate to="/login" />;
  }
};

export default PrivateRoutes;
